import React, { useCallback, useEffect, useState } from "react"
import AddressSelectionMap from "./AddressSelectionMap"
import { Address, Coordinates, Place, SavedAddress } from "../../types/address"
import SearchIcon from "../icons/SearchIcon"
import Skeleton from "react-loading-skeleton"
import SearchSection from "./SearchSection"
import CompleteAddress from "./CompleteAddress"
import AddressList from "./AddressList"
import { useDispatch, useSelector } from "react-redux"
import { APIProvider } from "@vis.gl/react-google-maps"
import { fetchDecodedAddress, getReverseGeocode } from "services/api/address"
import { AppDispatch, RootState } from "store"
import { useParams } from "react-router-dom"
import { fetchAddressThunk, fetchInfluencerAddressesThunk } from "slices/addressBook/thunk"
import { GOOGLE_MAPS_API_KEY } from "constants/global"

interface AddressBookProps {
    onSelection?: (address: SavedAddress) => void
    toggleAddNewSection?: (add: boolean) => void
}
const indiaCenter = {
    latitude: 22.9734, // Latitude
    longitude: 78.6569  // Longitude
};

const AddressBook: React.FC<AddressBookProps> = ({ onSelection, toggleAddNewSection }) => {

    const [addNew, setAddNew] = useState(false);
    const [coordinates, setCoordinates] = useState<Coordinates | null>(indiaCenter);

    const { collaborationId, campaignId } = useParams();

    const collaboration = useSelector((state: RootState) => state.legacyCollaborations.items[campaignId!]?.[collaborationId!]);
    const influencerId = collaboration?.collaboration?.influencer?.uuid;

    const hubId = useSelector((state: RootState) => state.auth.selectedHubId);
    // const [place, setPlace] = useState<Place | null>(null);
    const [decodedAddress, setDecodedAddress] = useState<Address | null>(null);
    const [selectedPlace, setSelectedPlace] = useState<any>(null);
    const [selectedAddressUUID, setSelectedAddressUUID] = useState<string | null>(null);
    const [recentlyAddedAddress, setRecentlyAddedAddress] = useState<SavedAddress | null>(null);

    const [fetching, setFetching] = useState(true);

    const [searchSection, setSearchSection] = useState(false);

    const [confirmLocation, setConfirmLocation] = useState(false);

    const dispatch: AppDispatch = useDispatch();


    const fetchAddressBook = useCallback((force = false) => {
        if (influencerId) {
            dispatch(fetchInfluencerAddressesThunk({ influencerId, force }));
        }
    }, [dispatch])

    const reverseGeocoding = async (coords: Coordinates) => {
        if (!hubId) return;
        try {
            setFetching(true);
            const result = await getReverseGeocode(hubId, coords);
            if (Array.isArray(result) && result.length > 0) {
                const reverseGeoCodedPlace: Place = result[0];
                const decoded = await fetchDecodedAddress(hubId, reverseGeoCodedPlace.place_id);
                setDecodedAddress(decoded);
                // setPlace(reverseGeoCodedPlace);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setFetching(false);
        }
    }

    const fetchPlaceData = async (placeId: string) => {
        if (!hubId) return;
        try {
            setFetching(true);
            const result: Address = await fetchDecodedAddress(hubId, placeId);
            if (result) {
                setCoordinates({ latitude: result.lat, longitude: result.lng });
                setDecodedAddress(result);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setFetching(false);
        }
    }


    useEffect(() => {
        if (toggleAddNewSection) {
            toggleAddNewSection(addNew);
        }
    }, [addNew, toggleAddNewSection])

    // useEffect(() => {
    //     if (coordinates) {
    //         reverseGeocoding(coordinates)
    //     }
    // }, [coordinates])

    return (
        <div className="address-selection">
            {
                addNew ? (
                    searchSection ? (
                        <SearchSection
                            onCancel={() => {
                                setSearchSection(false)
                            }}
                            currentGeolocation={coordinates ?? indiaCenter}
                            onPlaceSelection={(place) => {
                                console.log('Selected Place:', place);
                                setSearchSection(false);
                                fetchPlaceData(place.placePrediction.placeId)
                                setSelectedPlace(place);
                                // setPlace(place);
                            }}
                        />
                    ) :
                        (
                            <div className="map position-relative">
                                <div className="search-mockup-wrapper">
                                    <div className="search-mock " onClick={() => setSearchSection(true)}>
                                        <span className="search-text">Search a building, street name or area</span>
                                        <SearchIcon />
                                    </div>
                                </div>
                                <APIProvider apiKey={GOOGLE_MAPS_API_KEY}>
                                    <AddressSelectionMap
                                        coordinates={coordinates ?? { latitude: 0, longitude: 0 }}
                                        setCoordinates={(coords) => {
                                            setCoordinates(coords);
                                            reverseGeocoding(coords);
                                        }}
                                    />
                                </APIProvider>
                                <div className="located-address-wrapper">
                                    {
                                        confirmLocation && coordinates && decodedAddress ? (
                                            <CompleteAddress
                                                decodedAddress={decodedAddress}
                                                coords={coordinates}
                                                onCancel={() => setConfirmLocation(false)}
                                                afterSubmit={(uuid) => {
                                                    setAddNew(false)
                                                    if (influencerId) {
                                                        fetchAddressBook(true);
                                                    } else {
                                                        dispatch(fetchAddressThunk({ addressUUID: uuid, force: true })).then((res: any) => {
                                                            const address = res.payload.address;
                                                            if(address){
                                                                setRecentlyAddedAddress(address);
                                                            }
                                                        })
                                                    }
                                                    setSelectedAddressUUID(uuid);
                                                }}
                                            />
                                        ) :
                                            (
                                                <React.Fragment>
                                                    {
                                                        (decodedAddress) &&
                                                        <div className="located-address">
                                                            <div className="located-address-content p-0">
                                                                <div className="located-address-content-secondary d-flex justify-content-between align-items-center gap-2">
                                                                    {
                                                                        fetching ? <Skeleton width={150} /> : <span>{decodedAddress?.formatted}</span>
                                                                    }
                                                                    <button onClick={() => setSearchSection(true)} className="change-location-btn">Change</button>
                                                                </div>
                                                            </div>
                                                            <div className="confirm-location-wrapper">
                                                                <button onClick={() => setConfirmLocation(true)} className="theme-btn theme-btn-primary btn w-100">
                                                                    Confirm Location
                                                                </button>
                                                            </div>
                                                        </div>
                                                    }
                                                </React.Fragment>
                                            )
                                    }

                                </div>
                            </div>
                        )
                ) :
                    (
                        <AddressList
                            onAddNew={() => {
                                setAddNew(true)
                            }}
                            onSelection={onSelection}
                            showRecentlyAddedAddress={!influencerId}
                            recentlyAddedAddress={recentlyAddedAddress}
                            selectedAddressUUID={selectedAddressUUID}
                        />
                    )
            }
        </div>
    )
}

export default AddressBook